// SPDX-License-Identifier: AGPL-3.0-or-later

import {ComposerStandardEmojiNode} from '@app/features/lexical/composer/nodes/ComposerStandardEmojiNode';
import {findBlockedUnicodeEmojis, stripBlockedUnicodeEmojis} from '@fluxer/constants/src/EmojiConstants';
import {mergeRegister} from '@lexical/utils';
import {$getSelection, $isRangeSelection, type LexicalEditor, TextNode} from 'lexical';

export function registerComposerEmojiFilter(editor: LexicalEditor): () => void {
	return mergeRegister(
		editor.registerNodeTransform(TextNode, (node) => {
			if (editor.isComposing()) return;
			const matches = findBlockedUnicodeEmojis(node.getTextContent());
			for (const match of matches.reverse()) {
				const selection = $getSelection();
				const key = node.getKey();
				const anchor = $isRangeSelection(selection) && selection.anchor.key === key ? selection.anchor.offset : null;
				const focus = $isRangeSelection(selection) && selection.focus.key === key ? selection.focus.offset : null;
				const mapOffset = (offset: number) => offset - Math.min(Math.max(offset - match.index, 0), match[0].length);
				node.spliceText(match.index, match[0].length, '');
				if ($isRangeSelection(selection)) {
					if (anchor !== null) selection.anchor.set(key, mapOffset(anchor), 'text');
					if (focus !== null) selection.focus.set(key, mapOffset(focus), 'text');
				}
			}
		}),
		editor.registerNodeTransform(ComposerStandardEmojiNode, (node) => {
			if (editor.isComposing()) return;
			const wire = node.getWireText();
			if (stripBlockedUnicodeEmojis(wire) !== wire) node.remove();
		}),
	);
}
